import { Navigation } from '../components/Navigation';
import  Footer from '../components/Footer';
import { sendPageView } from "../utils/AnalyticsTracking";

export default function Main({initialized, children}: {initialized: boolean, children: React.ReactNode}): JSX.Element {

    sendPageView(initialized);

    return(
        <div className="Main">
            <Navigation />
                {children}
            <Footer />
        </div>
    )
}
